/**
 * @file Main entry point — PBF Field Mode
 */

// CSS
import '@styles/variables.css';
import '@styles/base.css';
import '@styles/components.css';
import '@styles/views.css';
import '@styles/native.css';

// Core
import { registerView, navigate } from '@core/router.js';
import { on } from '@core/events.js';

// State
import { initSupabase } from '@state/supabase.js';
import { initSyncListeners } from '@state/sync.js';

// Auth
import { checkSession, initLoginForm, onAuthStateChange } from '@auth/index.js';

// Components
import { renderBottomNav } from '@components/bottom-nav.js';

// Views
import todayView from '@views/today.js';
import jobsView from '@views/jobs.js';
import jobDetailView from '@views/job-detail.js';
import leadsView from '@views/leads.js';
import leadDetailView from '@views/lead-detail.js';
import tasksView from '@views/tasks.js';
import customersView from '@views/customers.js';
import customerDetailView from '@views/customer-detail.js';
import timerView from '@views/timer.js';
import cameraView from '@views/camera.js';
import moreView from '@views/more.js';

// Register all views
registerView('today', todayView);
registerView('jobs', jobsView);
registerView('job-detail', jobDetailView);
registerView('leads', leadsView);
registerView('lead-detail', leadDetailView);
registerView('tasks', tasksView);
registerView('customers', customersView);
registerView('customer-detail', customerDetailView);
registerView('timer', timerView);
registerView('camera', cameraView);
registerView('more', moreView);

// Boot
document.addEventListener('DOMContentLoaded', async () => {
  // Initialize Supabase
  initSupabase();

  // Set up online/offline listeners
  initSyncListeners();

  // Wire up login form
  initLoginForm();

  // Listen for auth state changes
  onAuthStateChange();

  // Check for existing session
  const isAuthed = await checkSession();

  if (isAuthed) {
    renderBottomNav();
    navigate('today');
  }

  // When user logs in later
  on('auth:login', () => {
    renderBottomNav();
    navigate('today');
  });

  console.log('[PBF Field Mode] App initialized');
});
